export const setupSsid = "petWALK.control.SETUP"
export const InputUrl = "192.168.1.100"

